import { BlocksContent } from '@strapi/blocks-react-renderer';
import { compiler } from 'markdown-to-jsx';

import { BlockComponentModel } from '@/cms/types/blok-component';
import { SECTION_NAMES } from '@/integrations/trackingScripts/constants';

import { BlockHeader, BlockHeaderContent } from '@/cms/BlockHeaderContentDC';
import { BlockWrapper } from '@/cms/BlockWrapperDC';
import { CodeBlock } from '@/decodo/blocks/CodeBlock';
import { CodeBlockItemProps } from '@/decodo/components/atoms/CodeBlock/CodeBlockItem';
import { RichTextFieldStrapiProps } from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';

export interface CodeBlockStrapiProps {
  header?: BlockHeader;
  items: {
    language: CodeBlockItemProps['language'];
    code: RichTextFieldStrapiProps;
  }[];
  showLineNumbers?: boolean;
}

export function combineOnlyCodeTextsFromRichTextField(
  code: BlocksContent
): string {
  return code
    .map((block) =>
      block.children
        .map((text) =>
          'text' in text && block.type === 'code' ? text.text : ''
        )
        .join('\n')
    )
    .join('\n');
}

export function combineOnlyCodeTextsFromMarkdown(content: string): string {
  const markdown = compiler(content);

  if (Array.isArray(markdown.props.children)) {
    return markdown.props.children
      .filter((child: unknown) => {
        return (
          typeof child === 'object' &&
          child !== null &&
          'type' in child &&
          child.type === 'pre'
        );
      })
      .map((child: any) => {
        return child?.props?.children?.props?.children ?? '';
      })
      .join('\n');
  } else {
    return markdown?.props?.children?.props?.children ?? '';
  }
}

export function CodeBlockStrapi({
  block,
  ...rest
}: BlockComponentModel<CodeBlockStrapiProps>) {
  const { header, items, showLineNumbers } = block;

  return (
    <BlockWrapper {...rest} data-tracker-section={SECTION_NAMES.CODE_BLOCK}>
      <div>
        <BlockHeaderContent {...header}>
          <CodeBlock
            items={items.map((item) => {
              if (item.code.text2) {
                return {
                  code: combineOnlyCodeTextsFromMarkdown(item.code.text2),
                  language: item.language || 'Python',
                };
              }
              return {
                code: combineOnlyCodeTextsFromRichTextField(
                  item.code.text ?? []
                ),
                language: item.language || 'Python',
              };
            })}
            showLineNumbers={showLineNumbers}
          />
        </BlockHeaderContent>
      </div>
    </BlockWrapper>
  );
}
